import { render } from "./asideComp.vue?vue&type=template&id=5e3358b4&scoped=true"
import script from "./asideComp.js?vue&type=script&lang=js"
export * from "./asideComp.js?vue&type=script&lang=js"

import "./asideComp.vue?vue&type=style&index=0&id=5e3358b4&lang=scss&scoped=true"

import exportComponent from "C:\\workspace\\repository\\sprfidspring\\src\\main\\vue-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3358b4"]])

export default __exports__